import Request from "../utils/request";

import { ipUrl } from "./index";

/**********************************订单管理******************************************** */

//获取二维码
export function pay(data) {
  return Request({
    url: `${ipUrl}/order/doUnifiedOrder`,
    method: "post",
    data: data,
    headers: {
      customerId: JSON.parse(window.sessionStorage.getItem("user")).customer_id
    }
  });
}

//判断是否支付成功
export function judge(data) {
  return Request({
    url: `${ipUrl}/order/doResult`,
    method: "post",
    data: data,
    headers: {
      customerId: JSON.parse(window.sessionStorage.getItem("user")).customer_id
    }
  });
}

//修改单张图片订单 的状态
export function repaireOrderStatus(data) {
  return Request({
    url: `${ipUrl}/order/oStatus`,
    method: "post",
    data: data,
    headers: {
      customerId: JSON.parse(window.sessionStorage.getItem("user")).customer_id
    }
  });
}

//修改购物车订单 的状态
export function completePay(data) {
  return Request({
    url: `${ipUrl}/order/completePay`,
    method: "post",
    data: data,
    headers: {
      customerId: JSON.parse(window.sessionStorage.getItem("user")).customer_id
    }
  });
}

// 购买套餐支付完成后调用
export function addUserPackages(data) {
  return Request({
    url: `${ipUrl}/userPackages/addUserPackages`,
    method: "post",
    data: data,
    headers: {
      customerId: JSON.parse(window.sessionStorage.getItem("user")).customer_id
    }
  });
}



// WEBPACK FOOTER //
// ./src/service3/pay.js